import React from "react";

const ReturnArrow = () => {
    return (
        <svg  xmlns="http://www.w3.org/2000/svg" x="50" y="50" width="100" height="100" fill="#5cceee">
            <path d="M22,29.5h-9.5c-6.627,0-12-5.373-12-12V0" strokeMiterlimit="10" fill="none" stroke="#000000"/>
            <circle cx="29.875" cy="29.125" r="7.875" fill="none" stroke="#000000"/>
        </svg>  
    );
}

export default ReturnArrow;